import script from "./WizardSetWifiCompleteStep.vue?vue&type=script&setup=true&lang=js"
export * from "./WizardSetWifiCompleteStep.vue?vue&type=script&setup=true&lang=js"

import "./WizardSetWifiCompleteStep.vue?vue&type=style&index=0&id=025e6782&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-025e6782"]])

export default __exports__